// extracted by mini-css-extract-plugin
module.exports = {"wordmarkContainer":"_31JH0usq","logoBg":"_3g5GBVl7"};